import React from "react";
import Layout from "../Layout/Layout";
import PageTop from "../Layout/PageTop";
import "./Services.css";
import ServiceCard from "../Layout/ServiceCard";
import { servicesList } from "../../utils/serviceList";
import HomeContact from "../Layout/HomeContact";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <Layout>
      <PageTop title={"Services"} />
      <div className="serviceswrapper">
        <span className="subhead">our services</span>
        <span className="mainhead">what we offer</span>
        <span className="desc">
          At Techni Trust Technical Services, we specialize in providing
          high-quality technical and maintenance solutions across the UAE. Our
          expert team offers a comprehensive range of services for residential,
          commercial, and industrial projects. We deliver reliable,
          cost-effective, and efficient solutions that enhance the
          functionality, safety, and appearance of every space we work on.
        </span>
      </div>
      <div className="serviceLists">
        {servicesList.map((list, index) => (
          <Link to={"/services/" + list.ServiceName} key={index}>
            <ServiceCard
              // key={index}
              serviceName={list.ServiceName}
              desc={list.desc}
              image={list.Image}
            />
          </Link>
        ))}
      </div>
      <HomeContact />
    </Layout>
  );
};

export default Services;
